/**
 * デジタルサイネージ用モジュール
 *
 * @module app/signage/display/SignageDamageOverviewPage
 */
define(['module',
        'dojo',
        'dojo/_base/array',
        'dojo/_base/declare',
        'dojo/_base/lang',
        'dojo/dom-class',
        'dojo/dom-construct',
        'dojo/text!./templates/SignageDamageOverviewPage.html',
        'idis/service/Requester',
        'idis/view/Loader',
        '../_SignageBase',
        //'../../config',
        // 以下、変数で受けないモジュール
        'dijit/Dialog',
        'dijit/form/Form',
        'dijit/layout/BorderContainer',
        'dijit/layout/ContentPane',
        'idis/view/form/AclButton',
], function(module, dojo, array, declare, lang, domClass,domConstruct, template, Requester, Loader, _SignageBase) {

        // 前回表示データ
        // セッションストレージ等に保持するほうが良いか？
        var prevItemStore = {};

        /**
         *
         * @class SignageDamageOverviewPage
         * @extends module:idis/view/page/_PageBase~_PageBase
         */
        return declare(module.id.replace(/\//g, '.'), _SignageBase,
        /** @lends module:app/signage/display/SignageDamageOverviewPage~SignageDamageOverviewPage# */
        {
            // テンプレート文字列
            templateString: template,

            _timer: null,

            // 表示ページ
            _page: 0,

            // ページあたり表示件数
            PAGE_LIST_SIZE: 9,

            // ページ切替間隔時間（秒）
            SIGNAGE_UPDATE_INTERVAL: 10,

            // 値を表示する項目のリスト
            target: [
                {'item':'totalDamageNum', 'area':'totalDamageNumArea', 'area2':'totalDamageNumArea2'},
                {'item':'sedDamageNum', 'area':'sedDamageNumArea', 'area2':'sedDamageNumArea2'},
                {'item':'houseDamageNum', 'area':'houseDamageNumArea', 'area2':'houseDamageNumArea2'},
                {'item':'riverDamageNum', 'area':'riverDamageNumArea', 'area2':'riverDamageNumArea2'},
                {'item':'deadNum', 'area':'deadNumArea', 'area2':'deadNumArea2', 'area3':'deadNumArea3'},
                {'item':'unknownNum', 'area':'unknownNumArea', 'area2':'unknownNumArea2', 'area3':'unknownNumArea3'},
                {'item':'seriousNum', 'area':'seriousNumArea', 'area2':'seriousNumArea2', 'area3':'seriousNumArea3'},
                {'item':'mildNum', 'area':'mildNumArea', 'area2':'mildNumArea2', 'area3':'mildNumArea3'},
                {'item':'cutOffComNum', 'area':'cutOffComNumArea', 'area2':'cutOffComNumArea2'},
            ],

            // ルート要素に付与されるCSS
            baseClass: 'idis-Page idis-Page--signage',

            constructor: function() {
                this.inherited(arguments);
            },

            buildRendering: function() {
                this.inherited(arguments);
            },

            startup: function() {
                this.inherited(arguments);
                this.initPage();
            },

            destroy: function() {
                this.inherited(arguments);
                clearTimeout(this._timer);
            },

            /**
             * 画面表示
             */
            initPage: function() {
                this.setDamageOverviewInfo();
            },

            /**
             * 被害情報概況を設定します
             */
            setDamageOverviewInfo: function() {
                var promise = Requester.get('/data/signage/' + this._screenId +'.json', {
                    headers: {'Content-Type': 'application/json; charset=utf-8'},
                    handleAs: 'json',
                    preventCache : true
                }).then(lang.hitch(this, function (item) {
                    // 被害情報を設定
                    var damageOverviewInfo = item.items.filter(function(element) {
                        return element.municipalityName === null;
                    });
                    this.setDamageOverview(this, damageOverviewInfo);
                    // 各市町村ごとの情報を取得
                    var damageDetailList = item.items.filter(function(element) {
                        return element.municipalityName !== null;
                    });
                    this.setDamageDetailList(this, damageDetailList);
                    // 前回データを更新
                    prevItemStore[this._screenId] = item;

                }), function (error) {
                    if (error.response.status === 404) {
                        var damageOverviewInfo = {};
                        this.setDamageOverview(this, damageOverviewInfo);
                        var damageDetailList = [];
                        this.setDamageDetailList(this, damageDetailList);
                    } else {
                        this.chain.info('情報の取得に失敗しました。', 'エラー');
                    }
                });
                //ローダーの表示
                Loader.wait(promise);
            },

            /**
             * 集計値を設定します
             */
            setDamageOverview: function(self, item) {
                // 項目に取得した値を設定
                array.forEach(this.target, function(target){
                    self[target.item].innerHTML = item[0][target.item];
                });
                // 更新状態を設定
                this.setDamageOverviewUpdate(self, item);
            },

            /**
             * 画面上部エリアの更新状態を設定します
             */
            setDamageOverviewUpdate: function(self, item) {
                var updateFlg = false;
                // 画面右上部に表示する項目
                const list = ['deadNum', 'unknownNum', 'seriousNum', 'mildNum'];
                // 前回データがある場合のみ処理
                // 前回データがない場合（≒初回表示）は処理しない
                var prevItem = prevItemStore[this._screenId];
                if (!prevItem || !item) {
                    return;
                }
                var totalNum = prevItem.items[0];
                if (totalNum) {
                    array.forEach(this.target, function(target){
                        // 更新された項目にstyleを設定
                        if (totalNum[target.item] !== item[0][target.item]) {
                            domClass.add(self[target.area], 'update-column');
                            domClass.add(self[target.area2], 'update-column');
                            if (list.includes(target.item)) {
                                domClass.add(self[target.area3], 'update-column');
                            }
                            updateFlg = true;
                        } else {
                            domClass.remove(self[target.area], 'update-column');
                            domClass.remove(self[target.area2], 'update-column');
                            if (list.includes(target.item)) {
                                domClass.remove(self[target.area3], 'update-column');
                            }
                        }
                    });
                }
                // 更新された項目がある場合、通知音を鳴らす
                if (updateFlg) {
                    this.playAudio();
                }
            },


            /**
             * 被害情報概況を設定します
             */
            setDamageDetailList: function(self, data) {
                // 表示をクリア
                var damageOverviewTBody = dojo.byId('damageOverviewTBody');
                domConstruct.empty(damageOverviewTBody);

                // 表示対象ページの抽出
                var firstIndex = this.PAGE_LIST_SIZE * this._page;
                var lastIndex = this.PAGE_LIST_SIZE * (this._page + 1) - 1;
                var displayData = data.filter((element, index) =>
                    index >= firstIndex && index <= lastIndex
                );

                // 画面上のページ数表示
                self.currentPage.innerHTML = this._page + 1;
                self.totalPage.innerHTML = Math.ceil(data.length / this.PAGE_LIST_SIZE);

                var prevItem = prevItemStore[this._screenId];
                var damageDetailList = [];
                if (prevItem) {
                    damageDetailList = prevItem.items.filter(function(element) {
                        return element.municipalityName !== null;
                    });
                }
                var updateFlg = false;

                array.forEach(displayData, function(item){
                    // 被害概況の前回値
                    var damagePrevItem = null;
                    if (damageDetailList && damageDetailList.length > 0) {
                        damagePrevItem = damageDetailList.filter((element) =>
                            element.municipalityName === item.municipalityName
                        )[0];
                        // 新規のデータが追加された場合は前回値を0として設定
                        if (damagePrevItem === undefined) {
                            damagePrevItem = {"deadNum": 0, "unknownNum": 0, "seriousNum": 0, "mildNum": 0, "unknownSympNum": 0, "fullDestlHm": 0, 
                            "halfDestlHm": 0, "partDestlHm": 0, "fldAbvHm": 0, "fldBlwHm": 0, "unknownHm": 0};
                        }
                    }

                    var className = '';
                    var tr = domConstruct.create('tr');
                    // 市町村
                    domConstruct.place(domConstruct.create('td', {
                        innerHTML: item.municipalityName, class: 'align-middle text-center fw-bold first-col'}), tr);

                    // 死者
                    className = damagePrevItem && (damagePrevItem.deadNum !== item.deadNum) ? 'update-column' : '';
                    if (className)  { updateFlg = true; };
                    className = className + ' align-middle text-center';
                    domConstruct.place(domConstruct.create('td', {
                        innerHTML: '<span class="fs-6 mx-2">' + item.deadNum + ' 人' + '</span>', class: className}), tr);

                    // 行方不明者
                    className = damagePrevItem && (damagePrevItem.unknownNum !== item.unknownNum) ? 'update-column' : '';
                    if (className)  { updateFlg = true; };
                    className = className + ' align-middle text-center';
                    domConstruct.place(domConstruct.create('td', {
                        innerHTML: '<span class="fs-6 mx-2">' + item.unknownNum + ' 人' + '</span>', class: className}), tr);
                    
                    // 重傷者
                    className = '';
                    className = damagePrevItem && (damagePrevItem.seriousNum !== item.seriousNum) ? 'update-column' : '';
                    if (className)  { updateFlg = true; };
                    className = className + ' align-middle text-center';
                    domConstruct.place(domConstruct.create('td', {
                        innerHTML: '<span class="fs-6">' + item.seriousNum + ' 人' + '</span>', class: className}), tr);

                    // 軽傷者
                    className = damagePrevItem && (damagePrevItem.mildNum !== item.mildNum) ? 'update-column' : '';
                    if (className)  { updateFlg = true; };
                    className = className + ' align-middle text-center';
                    domConstruct.place(domConstruct.create('td', {
                        innerHTML: '<span class="fs-6 mx-2">' + item.mildNum + ' 人' + '</span>', class: className}), tr);

                    // 調査中
                    className = damagePrevItem && (damagePrevItem.unknownSympNum !== item.unknownSympNum) ? 'update-column' : '';
                    if (className)  { updateFlg = true; };
                    className = className + ' align-middle text-center';
                    domConstruct.place(domConstruct.create('td', {
                        innerHTML: '<span class="fs-6 mx-2">' + item.unknownSympNum + ' 人' + '</span>', class: className}), tr);

                    // 全壊
                    className = damagePrevItem && (damagePrevItem.fullDestlHm !== item.fullDestlHm) ? 'update-column' : '';
                    if (className)  { updateFlg = true; };
                    className = className + ' align-middle text-center';
                    domConstruct.place(domConstruct.create('td', {
                        innerHTML: '<span class="fs-6 mx-2">' + item.fullDestlHm + '</span>', class: className}), tr);

                    // 半壊
                    className = damagePrevItem && (damagePrevItem.halfDestlHm !== item.halfDestlHm) ? 'update-column' : '';
                    if (className)  { updateFlg = true; };
                    className = className + ' align-middle text-center';
                    domConstruct.place(domConstruct.create('td', {
                        innerHTML: '<span class="fs-6 mx-2">' + item.halfDestlHm + '</span>', class: className}), tr);

                    // 一部損壊
                    className = damagePrevItem && (damagePrevItem.partDestlHm !== item.partDestlHm) ? 'update-column' : '';
                    if (className)  { updateFlg = true; };
                    className = className + ' align-middle text-center';
                    domConstruct.place(domConstruct.create('td', {
                        innerHTML: '<span class="fs-6 mx-2">' + item.partDestlHm + '</span>', class: className}), tr);
                    
                    // 床上浸水
                    className = damagePrevItem && (damagePrevItem.fldAbvHm !== item.fldAbvHm) ? 'update-column' : '';
                    if (className)  { updateFlg = true; };
                    className = className + ' align-middle text-center';
                    domConstruct.place(domConstruct.create('td', {
                        innerHTML: '<span class="fs-6 mx-2">' + item.fldAbvHm + '</span>', class: className}), tr);

                    // 床下浸水
                    className = damagePrevItem && (damagePrevItem.fldBlwHm !== item.fldBlwHm) ? 'update-column' : '';
                    if (className)  { updateFlg = true; };
                    className = className + ' align-middle text-center';
                    domConstruct.place(domConstruct.create('td', {
                        innerHTML: '<span class="fs-6 mx-2">' + item.fldBlwHm + '</span>', class: className}), tr);

                    // 分類不明
                    className = damagePrevItem && (damagePrevItem.unknownHm !== item.unknownHm) ? 'update-column' : '';
                    if (className)  { updateFlg = true; };
                    className = className + ' align-middle text-center';
                    domConstruct.place(domConstruct.create('td', {
                        innerHTML: '<span class="fs-6 mx-2">' + item.unknownHm + '</span>', class: className}), tr);

                    domConstruct.place(tr, damageOverviewTBody);
                });

                // 次回表示ページ
                if (lastIndex >= data.length - 1) {
                    // 先頭ページ
                    this._page = 0;
                } else {
                    // 次ページ
                    this._page += 1;
                }  

                // 更新された項目がある場合、通知音を鳴らす
                if (updateFlg) {
                    this.playAudio();
                }

                // 定期更新処理
                this._timer = setTimeout(lang.hitch(this, function() {
                    self.setDamageDetailList(self, data);
                }), this.SIGNAGE_UPDATE_INTERVAL * 1000);
            }
        });
    });
